export const shortList = [
  {
    id: "sh-01",
    title: "十二点的光",
    category: "short",
    year: "2024",
    region: "中国大陆",
    director: "程未",
    cast: "李念、周航",
    duration: "18 分钟",
    rating: 8.1,
    views: 96000,
    updatedAt: "2024-10-20",
    tags: ["剧情", "温情", "夜晚"],
    summary: "深夜十二点，一盏突然亮起的窗灯，让两个失眠的人有了交谈的理由。",
    description:
      "值夜班的保安和住在顶楼的女孩，隔着一整栋楼的对角线，靠开关灯打招呼。十八分钟里几乎没有对白，却把一个城市里最轻盈的善意讲得清清楚楚。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20a%20single%20lit%20apartment%20window%20in%20a%20dark%20residential%20tower%20at%20midnight%2C%20warm%20amber%20rectangle%20of%20light%2C%20grainy%20film%20texture%2C%20minimal%20composition%2C%20no%20text&width=600&height=900&seq=cov-noon-light&orientation=portrait",
  },
  {
    id: "sh-02",
    title: "最后一班地铁",
    category: "short",
    year: "2023",
    region: "中国香港",
    director: "郑婉仪",
    cast: "何仲、林嘉",
    duration: "14 分钟",
    rating: 7.9,
    views: 74000,
    updatedAt: "2024-09-19",
    tags: ["悬疑", "都市", "短片"],
    summary: "末班车的车厢里只剩两个人，其中一个不应该出现在这里。",
    description:
      "加班到深夜的上班族赶上最后一班地铁，车厢里除了他只有一个穿旧西装的男人。列车在隧道里停了很久，广播重复着同一句话。十四分钟的悬疑，收尾干净利落。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20an%20empty%20subway%20carriage%20interior%20with%20flickering%20warm%20lights%20and%20a%20single%20distant%20silhouette%20at%20the%20far%20end%2C%20grainy%20film%20texture%2C%20tense%20mood%2C%20no%20text&width=600&height=900&seq=cov-last-metro&orientation=portrait",
  },
  {
    id: "sh-03",
    title: "纸飞机",
    category: "short",
    year: "2022",
    region: "日本",
    director: "中村凉太",
    cast: "森川千夏、松本航",
    duration: "11 分钟",
    rating: 8.4,
    views: 128000,
    updatedAt: "2024-07-30",
    tags: ["温情", "童年", "治愈"],
    summary: "从五楼窗口飞出的纸飞机，落到了一个陌生人的阳台上。",
    description:
      "小男孩每天折一只纸飞机，写上想说的话，从窗口放飞。某天，一架纸飞机被捡起并折了回来。十一分钟的小故事，把陌生人之间的连接拍得干净又动人。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20a%20white%20paper%20plane%20flying%20over%20sunlit%20apartment%20balconies%20with%20laundry%20and%20plants%2C%20soft%20golden%20afternoon%20light%2C%20grainy%20film%20texture%2C%20warm%20palette%2C%20no%20text&width=600&height=900&seq=cov-paper-plane&orientation=portrait",
  },
  {
    id: "sh-04",
    title: "雨停之后",
    category: "short",
    year: "2024",
    region: "欧美",
    director: "Camille Roux",
    cast: "Ana Petit、Luc Moreau",
    duration: "22 分钟",
    rating: 8.0,
    views: 61000,
    updatedAt: "2024-08-22",
    tags: ["爱情", "文艺", "短片"],
    summary: "一场雨把两个原本要告别的人困在了同一间咖啡馆。",
    description:
      "分手当天，大雨把两人困在街角咖啡馆。他们开始整理共同的物品，一件件决定归属。雨停的时候，桌上已经空了，窗外的路也干了。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20of%20a%20rain%20streaked%20cafe%20window%20with%20two%20coffee%20cups%20and%20warm%20interior%20glow%20reflecting%20on%20the%20glass%2C%20soft%20bokeh%2C%20grainy%20film%20texture%2C%20no%20text&width=600&height=900&seq=cov-after-rain&orientation=portrait",
  },
];

export const animationList = [
  {
    id: "an-01",
    title: "云上邮局",
    category: "animation",
    year: "2024",
    region: "中国大陆",
    director: "苏南",
    cast: "配音：叶知秋、林木",
    duration: "96 分钟",
    rating: 8.7,
    views: 356000,
    updatedAt: "2024-11-14",
    tags: ["动画", "奇幻", "治愈"],
    summary: "一座漂浮在云层里的邮局，专门投递寄不到的思念。",
    description:
      "云上邮局的邮差每天骑着纸鹤，把信件送到人间最需要的地方。新来的实习生发现，有一封信在邮局里放了四十年始终送不出去。手绘风格的画面与柔和的配乐，让整部片子像一场安静的梦。",
    cover:
      "https://readdy.ai/api/search-image?query=Whimsical%20hand%20painted%20animation%20poster%20artwork%20of%20a%20tiny%20post%20office%20floating%20among%20soft%20golden%20clouds%20with%20paper%20cranes%20flying%2C%20warm%20pastel%20palette%2C%20grainy%20texture%2C%20storybook%20mood%2C%20no%20text&width=600&height=900&seq=cov-cloud-post-office&orientation=portrait",
  },
  {
    id: "an-02",
    title: "星星修补师",
    category: "animation",
    year: "2023",
    region: "日本",
    director: "高桥悠",
    cast: "配音：森下有纪、小林澄",
    duration: "104 分钟",
    rating: 8.9,
    views: 412000,
    updatedAt: "2024-10-08",
    tags: ["动画", "治愈", "奇幻"],
    summary: "一位专门修补星星的老人，遇见了一颗拒绝发光的星。",
    description:
      "夜空里的星星会老化、会熄火，修补师的工作就是爬上梯子把它们一颗颗修好。某天他遇到一颗怎么修都不肯亮的星，才发现它只是不想再为别人照明。温柔的故事，配上极美的夜景画面。",
    cover:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20film%20poster%20artwork%20of%20an%20old%20man%20on%20a%20tall%20ladder%20repairing%20glowing%20amber%20stars%20in%20a%20deep%20night%20sky%2C%20soft%20warm%20glow%2C%20hand%20painted%20texture%2C%20storybook%20mood%2C%20no%20text&width=600&height=900&seq=cov-star-mender&orientation=portrait",
  },
  {
    id: "an-03",
    title: "会飞的鲸",
    category: "animation",
    year: "2022",
    region: "欧美",
    director: "Alice Warren",
    cast: "配音：Clara Dunn、Henry Vale",
    duration: "89 分钟",
    rating: 8.5,
    views: 187000,
    updatedAt: "2024-06-26",
    tags: ["动画", "冒险", "奇幻"],
    summary: "一头想飞的鲸鱼和一个不会游泳的女孩，一起造了一艘船。",
    description:
      "海边的鲸鱼每天仰望天空，镇上的女孩每天望着海。两个人花了一整个夏天，把废弃木料拼成一艘奇怪的船。关于梦想与笨拙努力的动画冒险，适合全家一起看。",
    cover:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20film%20poster%20artwork%20of%20a%20gentle%20whale%20floating%20above%20a%20small%20wooden%20boat%20on%20a%20calm%20golden%20sea%20at%20sunset%2C%20hand%20painted%20texture%2C%20soft%20warm%20palette%2C%20dreamy%20mood%2C%20no%20text&width=600&height=900&seq=cov-flying-whale&orientation=portrait",
  },
  {
    id: "an-04",
    title: "森林的第十二个月",
    category: "animation",
    year: "2021",
    region: "欧美",
    director: "Daniel Frost",
    cast: "配音：Eva Marsh、Ryan Cole",
    duration: "82 分钟",
    rating: 8.3,
    views: 143000,
    updatedAt: "2024-04-18",
    tags: ["动画", "童话", "自然"],
    summary: "森林里多出来的第十三个月，只有动物们知道它在哪里。",
    description:
      "每年冬天最冷的那几天，森林会悄悄多出一个月。这个月里，所有动物都停止冬眠，聚在一起开一场漫长的会议。画风来自手工剪纸，配色温暖，故事古老又新鲜。",
    cover:
      "https://readdy.ai/api/search-image?query=Whimsical%20paper%20cut%20animation%20poster%20artwork%20of%20a%20snowy%20forest%20clearing%20with%20warm%20lanterns%20and%20small%20animal%20silhouettes%20gathered%20around%20a%20fire%2C%20handmade%20texture%2C%20warm%20amber%20palette%2C%20no%20text&width=600&height=900&seq=cov-twelfth-month&orientation=portrait",
  },
];